import { useQuery } from "@apollo/client";
import { gql } from "@apollo/client";
import { Category } from "@/types";

const GET_CATEGORIES = gql`
  query GetCategories($brandId: Uuid!, $filter: CategoriesFilterInput) {
    categories(input: { brandId: $brandId, filter: $filter }) {
      id
      name
      slug
      imageUrl
      priority
      isActive
      pointBinds {
        pointId
        orderType
      }
    }
  }
`;

interface UseCategoriesResult {
  categories: Category[];
  loading: boolean;
  error: Error | undefined;
  refetch: () => void;
}

interface UseCategoriesVariables {
  brandId: string | null;
  filter?: {
    isActive?: boolean;
    pointId?: string;
  };
}

export const useCategories = ({
  brandId,
  filter,
}: UseCategoriesVariables): UseCategoriesResult => {
  const { data, loading, error, refetch } = useQuery(GET_CATEGORIES, {
    variables: {
      brandId,
      filter: {
        isActive: true,
        ...filter,
      },
    },
    skip: !brandId,
    errorPolicy: "all",
  });

  return {
    categories: data?.categories || [],
    loading,
    error,
    refetch,
  };
};
